import { useState as a, useRef as f, useEffect as i } from "react";
const p = ({ hoverOpenDelay: o = 100 } = {}) => {
  const [s, r] = a(!1), e = f(null), t = () => {
    e.current !== null && (clearTimeout(e.current), e.current = null);
  }, n = () => {
    t(), r(!0);
  }, u = () => {
    t(), e.current = setTimeout(() => {
      r(!0);
    }, o);
  }, c = () => {
    t(), r(!1);
  }, l = () => {
    t(), e.current = setTimeout(() => {
      r(!1);
    }, 100);
  };
  return i(() => () => t(), []), { show: s, open: n, close: c, delayClose: l, delayOpen: u };
};
export {
  p as useFloatHover
};
